import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Party, PartyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import { useMarketPlace } from 'hooks/useMarketPlace';
import React from 'react';
import ClaimAlert from './components/ClaimAlert';
import PdfValidation from './components/PdfValidation';
import Sdn from './components/Sdn';
import Validation from './components/Validation';
import Watchlist from './components/Watchlist';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    w100: {
      width: '100%',
    },
  }),
);

const PartyOrderInsights: React.FC<PartyOrderInsightsProps> = ({ party, isPdf, index = 0, enableStatus, timezone }) => {
  const classes = useStyles();
  const shouldHideContactValidationSection = false;
  const shouldHideIdentityVerificationSection = false;
  const marketPlace = useMarketPlace();
  const [currentParty, setCurrentParty] = React.useState<Party>(party);

  const updatedPartyInfo = (updatedFields?: Partial<Party>) => {
    setCurrentParty((prevParty) => ({
      ...prevParty,
      ...updatedFields,
    }));
  };
  return (
    <div className={classes.w100}>
      <Sdn party={currentParty} isPdf={isPdf} />
      {currentParty && currentParty.filePartyType !== 'Lender' && (
        <>
          <Watchlist party={currentParty} isPdf={isPdf} />
          <ClaimAlert party={currentParty} isPdf={isPdf} />
          {(currentParty.partyType === 'Individual' || currentParty.partyType === 'A Married Couple') && !isPdf && (
            <>
              {enableStatus?.contactValidation !== undefined && !shouldHideContactValidationSection && (
                <Validation
                  party={currentParty}
                  hasRisks={Boolean(currentParty.contactValidation?.risks?.length)}
                  title="Contact Validation"
                  description={enableStatus.contactValidation.description}
                  isEnabled={enableStatus.contactValidation.enabled}
                  productCode={enableStatus.contactValidation.productCode}
                  qaPrefix={`contact-validation`}
                  index={index}
                  updatedPartyInfo={updatedPartyInfo}
                  marketPlace={marketPlace}
                />
              )}
              {enableStatus?.enhancedIdentityVerification !== undefined && !shouldHideIdentityVerificationSection && (
                <Validation
                  party={currentParty}
                  hasRisks={Boolean(currentParty.enhancedIdentifyVerification?.summary?.risks?.length)}
                  title="Identity Verification"
                  description={enableStatus.enhancedIdentityVerification.description}
                  isEnabled={enableStatus.enhancedIdentityVerification.enabled}
                  productCode={enableStatus.enhancedIdentityVerification.productCode}
                  qaPrefix={`identity-verification`}
                  updatedPartyInfo={updatedPartyInfo}
                  index={index}
                  type="EnhancedIdentityVerification"
                  marketPlace={marketPlace}
                />
              )}
            </>
          )}
          {(party.partyType === 'Individual' || party.partyType === 'A Married Couple') && isPdf && (
            <>
              <PdfValidation
                party={currentParty}
                hasRisks={Boolean(currentParty.contactValidation?.risks?.length)}
                title="Contact Validation"
                isEnabled={enableStatus?.contactValidation?.enabled}
              />
              <PdfValidation
                party={currentParty}
                hasRisks={Boolean(currentParty.enhancedIdentifyVerification?.summary?.risks?.length)}
                timezone={timezone}
                title="Identity Verification"
                type="EnhancedIdentityVerification"
                isEnabled={enableStatus?.enhancedIdentityVerification?.enabled}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PartyOrderInsights;
